import { Button, Col, Form, Modal, Row, notification } from "antd";
import InputComponent from "../InputComponent";
import SelectComponent from "../SelectComponent";
import { FormattedMessage } from "react-intl";
import countries from "../../data/countries.json";
import {
  getFormattedDateAndTime,
  getTranslatedValue,
  getUsername,
} from "../../utils/Utils";
import { useEffect, useRef, useState } from "react";
import { toUpdateAssessment } from "../../utils/APIs";
import moment from "moment";
import FirstBlock from "./FirstBlock";
import ThirdBlock from "./ThirdBlock";
import FourthBlock from "./FourthBlock";
import FifthBlock from "./FifthBlock";
import SixthBlock from "./SixthBlock";
import Reference from "./Reference";
import ThereMore from "./ThereMore";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ScreenLoader from "../ScreenLoader";

const PracticePatientForm = ({ selected, ToolStore }) => {
  const printRef = useRef();
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    form.setFieldsValue({
      address: selected?.results?.adress?.value,
      zipcode: selected?.results?.zipcode?.value,
      country: selected?.results?.country?.value,
      practiceName: selected?.results?.practiceName?.value,
      docFirstName: selected?.results?.doctorFirstName?.value,
      docLastName: selected?.results?.doctorLastName?.value,
      email: selected?.results?.email?.value,
    });
  }, [selected]);

  const handleSumbit = async (type) => {
    try {
      const values = await form.validateFields();
      const l__selected = { ...selected };
      l__selected.results.adress.value = form.getFieldValue("address");

      l__selected.results.zipcode.value = form.getFieldValue("zipcode");
      l__selected.results.country.value = form.getFieldValue("country");
      l__selected.results.practiceName.value =
        form.getFieldValue("practiceName");
      l__selected.results.doctorFirstName.value =
        form.getFieldValue("docFirstName");
      l__selected.results.doctorLastName.value =
        form.getFieldValue("docLastName");
      l__selected.results.email.value = form.getFieldValue("email");
      l__selected.results.key = l__selected.id;
      toUpdateAssessment(
        l__selected,
        l__selected.calculatedValues,
        -1,
        -1,
        l__selected.status,
      ).then((res) => {
        setIsModalOpen(true);
      });
    } catch (errorInfo) {
      const messages = errorInfo.errorFields
        .reverse()
        .map((field) => field.name)
        .flat();
      notification.error({
        message: getTranslatedValue("validationFailed"),
        description: (
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {messages.map((msg, idx) => (
              <li
                className="roi--floating-input"
                style={{ padding: 0 }}
                key={idx}
              >
                {getTranslatedValue(msg)}
              </li>
            ))}
          </ul>
        ),
        duration: 5,
      });
    }
  };

  const handleExportPdf = async () => {
    setLoading(true);
    const element = printRef.current;
    try {
      html2canvas(element, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");

        const imgWidthPx = canvas.width;
        const imgHeightPx = canvas.height;

        // Convert pixels to mm (1 px ≈ 0.264583 mm)
        const pxToMm = (px) => px * 0.264583;
        const pdfWidth = pxToMm(imgWidthPx);
        const pdfHeight = pxToMm(imgHeightPx);

        // Create PDF with same dimensions as image
        const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight]);
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(
          `${moment(new Date()).format("DD-MM-YYYY")}_${
            selected?.results?.doctorFirstName?.value +
            "_" +
            selected?.results?.doctorLastName?.value
          }.pdf`,
        );
        setLoading(false);
        setIsModalOpen(false);
      });
    } catch (error) {
      setLoading(false);
    }
  };

  const modal = () => {
    return (
      <Modal
        open={isModalOpen}
        className="roi--modal-export"
        onCancel={() => setIsModalOpen(false)}
        width={"140vh"}
        style={{ top: 20 }}
        title={
          <span className="roi--export-title">
            {getTranslatedValue("previewPdf")}
          </span>
        }
        footer={
          <div style={{ textAlign: "center", marginTop: "2vh" }}>
            <Button
              className="roi--button-third"
              style={{
                marginTop: "4vh",
                textAlign: "center",
                marginBottom: "2vh",
              }}
              onClick={(e) => setIsModalOpen(false)}
            >
              <FormattedMessage id="annuler" />
            </Button>

            <Button
              className="roi--button-primary"
              style={{
                marginTop: "4vh",
                textAlign: "center",
                marginBottom: "2vh",
                marginLeft: "2vh",
              }}
              onClick={(e) => handleExportPdf(e)}
            >
              <FormattedMessage id="export" />
            </Button>
          </div>
        }
      >
        <div ref={printRef}>
          <div style={{ textAlign: "center", paddingTop: "2vh" }}>
            <img
              src="/images/icons/monitoringText.png"
              style={{ width: "300px", marginLeft: "2vh" }}
            />
          </div>

          <div
            className="roi--background-section"
            style={{ paddingBottom: "4vh", marginTop: "4vh" }}
          >
            <Row style={{ paddingTop: "2vh" }}>
              <Col span="10" style={{ marginLeft: "6vh" }}>
                <span className="roi--title-pdf">
                  {selected?.results?.practiceName?.value}
                </span>
              </Col>
              <Col
                span="12"
                style={{ textAlign: "right", paddingRight: "1vh" }}
              >
                <span className="roi--title-pdf">
                  {selected?.results?.doctorFirstName?.value +
                    " " +
                    selected?.results?.doctorLastName?.value}
                </span>
              </Col>
              <Col span="2" />
            </Row>

            <Row style={{ paddingTop: "2vh", paddingRight: "1vh" }}>
              <Col span="10" style={{ marginLeft: "6vh" }}>
                <span className="roi--title-pdf">
                  {getFormattedDateAndTime(new Date())}
                </span>
              </Col>
              <Col span="12" style={{ textAlign: "right" }}>
                <span className="roi--title-pdf">{getUsername(ToolStore)}</span>
              </Col>
              <Col span="2" />
            </Row>
          </div>
          <div
            className="roi--patient-exp-acq-container"
            style={{ maxWidth: "100%" }}
          >
            <div className="roi--patient-exp-acq-title">
              <span>
                <FormattedMessage id="Patienexperienceandacquisition" />
              </span>
            </div>
            <FirstBlock
              happyPatient={selected?.calculatedValues?.happyPatient}
              percentageDmPatient={
                selected?.calculatedValues?.percentageDmPatient
              }
            />
            {/* <SecondBlock /> */}
          </div>
          <div
            className="roi--patient-exp-acq-container"
            style={{ maxWidth: "100%" }}
          >
            <div className="roi--patient-exp-acq-title">
              <span>
                <FormattedMessage id="potentialPatientFeedback" />
              </span>
            </div>

            <ThirdBlock
              practiceEfficiency={
                selected?.calculatedValues?.practiceEfficiency
              }
            />
            <FourthBlock
              potentialImpact={selected?.calculatedValues?.potentialImpact}
            />
            <FifthBlock timeSaved={selected?.calculatedValues?.timeSaved} />
            <SixthBlock
              countryId={selected?.countryId}
              symbol={selected?.symbol}
              revenue={selected?.calculatedValues?.revenue}
            />

            <Reference />
          </div>
          <ThereMore result={selected?.calculatedValues} inModal={true} />
        </div>
      </Modal>
    );
  };

  return (
    <div className="roi--patient-exp-acq-container">
      <div className="roi--patient-exp-acq-title">
        <span>
          <FormattedMessage id="practiceProfile" />
        </span>
      </div>
      <Form form={form} layout="vertical" onChange={(e) => console.log()}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="address"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <InputComponent
                label={<FormattedMessage id="Adress" />}
                name={"address"}
                type={"text"}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="zipcode"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <InputComponent
                label={<FormattedMessage id="zipcode" />}
                name={"zipCode"}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="country"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <SelectComponent
                label={<FormattedMessage id="country" />}
                name={"country"}
                options={countries
                  .sort((a, b) => a.title_en.localeCompare(b.title_en))
                  .map((c) => ({
                    label: c.title_internal,
                    value: c.id,
                  }))}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              name="practiceName"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <InputComponent
                label={<FormattedMessage id="practiceName" />}
                name={"Practice names"}
                type={"text"}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="docFirstName"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <InputComponent
                label={<FormattedMessage id="docFirstName" />}
                name={"firstName"}
                type={"text"}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="docLastName"
              rules={[
                {
                  required: true,
                  message: "",
                },
              ]}
            >
              <InputComponent
                label={<FormattedMessage id="docLastName" />}
                name={"lastName"}
                type={"text"}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="email"
              rules={[
                {
                  type: "email",
                  required: true,
                  message: getTranslatedValue("emailNotValid"),
                },
              ]}
            >
              <InputComponent
                label={<FormattedMessage id="email" />}
                name={"Email"}
                type={"email"}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" gutter={16} style={{ marginTop: "2vh" }}>
          <Col>
            <Button
              className="roi--button-form roi--button-saved"
              onClick={() => handleSumbit(1)}
            >
              <FormattedMessage id="downloadSimulation" />
            </Button>
          </Col>
          <Col>
            {/* <Button className="roi--button-form roi--button-generate">
              <FormattedMessage id="shareSimulation" />
            </Button> */}
          </Col>
        </Row>
      </Form>
      {modal()}
      {loading && <ScreenLoader />}
    </div>
  );
};

export default PracticePatientForm;
